import React from "react";
import styled from "styled-components";
import { Input, Button, Checkbox } from "antd";
import Colors from "../../constants/Colors";
import Fonts from "../../constants/Fonts";
/**
 * Consigner Profile Form
 */

const Container = styled.div`
  font-family: ${Fonts.CONSIGNER};
  width: 100%;
`;
const AuthInput = styled(Input)`
  font-family: ${Fonts.CONSIGNER};
  width: 100%;
  height: 65px;
  padding: 16px;
  margin: 10px auto;
  border: 1px solid var(--stroke-color, #e4e4e7);
  background: var(--base-white, #fff);
  font-size: 16px;
`;
const PassInput = styled(Input.Password)`
  font-family: ${Fonts.CONSIGNER};
  width: 100%;
  height: 65px;
  padding: 16px;
  margin: 10px auto;
  border: 1px solid var(--stroke-color, #e4e4e7);
  background: var(--base-white, #fff);
  &.ant-input-affix-wrapper > .ant-input {
    font-size: 16px;
  }
`;

const UserHelpActions = styled.div`
  font-family: ${Fonts.CONSIGNER};
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 10px 0;
  label,
  a {
    color: var(--heading-color, #2e2e2e);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
  }
`;

interface Props {
  onLogin(email: string, password: string): void;
  email: string;
  password: string;
  rememberSession: boolean;
  onEmailChange(newEmail: string): void;
  onPasswordChange(newPassword: string): void;
  onRememberSessionChange(newValue: boolean): void;
  loginLoading: boolean;
  title?: string;
  buttonText?: string;
}

const ConsignerLoginForm = (props: Props): JSX.Element => {
  const {
    email,
    password,
    rememberSession,
    onEmailChange,
    onPasswordChange,
    onRememberSessionChange,
    onLogin,
    loginLoading,
    buttonText,
    title,
  } = props;

  return (
    <Container>
      <AuthInput
        data-testid="email"
        value={email}
        type="email"
        onChange={(e) => onEmailChange(e.target.value)}
        placeholder="Enter Email"
      />
      <PassInput
        className="red"
        data-testid="password"
        value={password}
        onChange={(e) => onPasswordChange(e.target.value)}
        placeholder="Enter Password"
      />
      <UserHelpActions>
        <span>
          <Checkbox
            id="rememberSession"
            value={rememberSession}
            onChange={(e) => onRememberSessionChange(e.target.value)}
          ></Checkbox>
          <label htmlFor="rememberSession" style={{ marginLeft: "10px" }}>
            Remember Me?
          </label>
        </span>
        <a href="/forgot" data-testid="forgot" style={{ color: Colors.BLACK }}>
          Forgot Password?
        </a>
      </UserHelpActions>
      <Button
        style={{
          display: "flex",
          width: "100%",
          height: 65,
          padding: 16,
          justifyContent: "center",
          alignItems: "center",
          marginTop: 10,
          marginBottom: 10,
          textAlign: "center",
          fontSize: 16,
          fontWeight: 600,
          lineHeight: 28,
        }}
        data-testid="loginBtn"
        onClick={() => onLogin(email, password)}
        type="primary"
        loading={loginLoading}
      >
        {buttonText ? buttonText : "Sign In"}
      </Button>
      <div
        style={{
          textAlign: "center",
          padding: "10px",
          fontSize: 14,
          fontWeight: 600,
        }}
      >
        Don&apos;t have an account?{" "}
        <a href="/signup" data-testid="signup">
          Sign up
        </a>
      </div>
    </Container>
  );
};

export default ConsignerLoginForm;
